module.exports = __webpack_public_path__ + "static/design_and_space_planning-e04c0dbd240e10c9638c17e3469cd4b4.jpg";